export default "/images/vendor/@coreui/icons/svg/flag/cif-tj.svg?5f2589986bd1698eaac1c1eda65a78af";